export enum UnitTransportTypes {
    TRUCK = 1,
    CONTAINER = 2
}